import { FormTextInputComponent } from 'src/features/generalForms/builder/types/TextInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { RPDF } from 'src/features/report/react-pdf';

export const FormTextInput: FormTextInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return <AnswerPreviewRow<string> value={value} isOptional={props.isOptional} renderValue={(val) => val} {...props} />;
};
